import { callFes } from '../index';

export const checkTLS = async (email: string): Promise<boolean> => {
  const data = await callFes.post(`mail-service/check-tls`, { email }, true);

  if (data.error || data.tlsSupport === false) {
    return false;
  }
  return true;
};
